import { useState, useEffect } from 'react';
import { Sidebar } from './Sidebar';
import { MobileNav } from './MobileNav';
import { cn } from '@/lib/utils';

export function LawyerLayout({ children }) {
  // Get collapsed state from localStorage to match sidebar
  const [isCollapsed, setIsCollapsed] = useState(() => {
    const saved = localStorage.getItem('lawyer-sidebar-collapsed');
    return saved ? JSON.parse(saved) : false;
  });

  // Listen for storage changes (when sidebar toggles)
  useEffect(() => {
    const handleStorageChange = () => {
      const saved = localStorage.getItem('lawyer-sidebar-collapsed');
      setIsCollapsed(saved ? JSON.parse(saved) : false);
    };

    // Check periodically for changes (localStorage events only fire across tabs)
    const interval = setInterval(handleStorageChange, 100);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="min-h-screen bg-slate-50">
      <Sidebar />
      <MobileNav />
      <main
        className={cn(
          'transition-all duration-200 ease-in-out min-h-screen',
          // Mobile: no left margin, add top padding for mobile header
          'pt-14 md:pt-0',
          // Desktop: left margin for sidebar
          isCollapsed ? 'md:ml-16' : 'md:ml-64'
        )}
      >
        {children}
      </main>
    </div>
  );
}
